<template>
    <div class="quick-profile" :class="{'hide':!this.display}">
        <div class="card-icon">
            <img id="card-icon-img" :src="this.profile.url"/>
        </div>
        <div class="card-brief-item card-name" >
            {{ this.profile.title }}
        </div>
        <div class="card-brief-item card-description">
            {{ this.profile.des }}
        </div>
        <div class="card-brief-item card-description" :class="{'hide':this.level !== 4 }">
            checkin status: {{ this.checkinStatus }}
        </div>
        <div class='blank'></div>
        <button class="tube-button full" @click='addContact' :class="{'hide':this.level !== 1}">add as friend</button>
        <div class='blank' :class="{'hide':this.level !== 1}"></div>
        <button class="tube-button full" @click='chatContact' :class="{'hide':this.level !== 2 || this.$route.name === 'chatPage'}">chat</button>
        <div class='blank' :class="{'hide':this.level !== 2}"></div>
        <button class="tube-button full" @click='deleteContact' :class="{'hide':this.level !== 2}">delete</button>
        <div class='blank' :class="{'hide':this.level !== 2}"></div>
        <button class="tube-button full" @click='joinGroup' :class="{'hide':this.level !== 3}">join group</button>
        <div class='blank' :class="{'hide':this.level !== 3}"></div>
        <button class="tube-button full" @click='chatGroup' :class="{'hide':this.level !== 4 || this.$route.name === 'chatPage'}">chat in group</button>
        <div class='blank' :class="{'hide':this.level !== 4  || this.$route.name === 'chatPage'}"></div>
        <button class="tube-button full" @click='checkinGroup' :class="{'hide':this.level !== 4}">checkin</button>
        <div class='blank' :class="{'hide':this.level !== 4 }"></div>
        <button class="tube-button full" @click='leaveGroup' :class="{'hide':this.level !== 4}">leave group</button>
        <div class='blank' :class="{'hide':this.level !== 4 }"></div>
        <button class="tube-button full" @click='switchChangeSheet' :class="{'hide':this.level !== 4 || !this.isAdmin}">change group info</button>
       
        <div class='blank' :class="{'hide':!this.showSheet}" ></div>
        <input  type="file" class="inputfile" name="upload" id='upload' accept="image/jpeg" :class="{'hide':!this.showSheet}" :disabled='sending'>
        <label class="profile-brief-item tube-button" for="upload" :class="{'hide':!this.showSheet}" :disabled='sending'>Choose a photo</label>
        <div class='blank' :class="{'hide':!this.showSheet}" ></div>
        <input class="tube-input" v-model="newTitle" placeholder="new group name" type="text" :class="{'hide':!this.showSheet}" :disabled='sending'>
        <div class='blank' :class="{'hide':!this.showSheet}" ></div>
        <input class="tube-input" v-model="newDes" placeholder="new des" type="text" :class="{'hide':!this.showSheet}" :disabled='sending'>
        <div class='blank' :class="{'hide':!this.showSheet}" ></div>
        <button class="tube-button full" :class="{'hide':!this.showSheet}" @click='changeGroupInfo' :disabled='sending'>apply change</button>
    </div>
</template>
<script>
export default {
    name: 'quickProfile',
    props:['profile','display'],
    data: function(){
        return{
            showSheet:false,
            sending:false,
            newTitle:'',
            newDes:'',
            sending:false
        }
    },
    methods:{
        addContact(){
            console.log('addContact');
            this.$socket.emit('contactAction',{action:'add',targetUid:this.profile.uid});
        },
        chatContact(){
            console.log('chatContact');
            this.$socket.emit('initChat',{targetUid:this.profile.uid,sourceUid:this.$store.state.UID});
        },
        deleteContact(){
            console.log('deleteContact');
            this.$socket.emit('contactAction',{action:'delete',targetUid:this.profile.uid});
            if(this.$route.name === 'chatPage')this.$router.push({path:`/home`,replace:true});
        },
        joinGroup(){
            console.log('joinGroup');
            this.$socket.emit('groupAction',{action:'join',cid:this.profile.cid});
        },
        chatGroup(){
            console.log('chatGroup');
            this.$store.state.searchPageModalOpen=false;
            this.$router.push({path:`/chatPage/${this.profile.cid}`,replace:true});
        },
        leaveGroup(){
            console.log('leaveGroup');
            this.$socket.emit('groupAction',{action:'leave',cid:this.profile.cid});
            if(this.$route.name === 'chatPage')this.$router.push({path:`/home`,replace:true});
        },
        checkinGroup(){
            console.log('checkinGroup');
            this.$socket.emit('groupAction',{action:'checkin',cid:this.profile.cid});
        },        
        switchChangeSheet(){
            this.showSheet=!this.showSheet;
        },
        changeGroupInfo(){
            this.sending=true;
            let fd=new FormData();
            fd.append('mail',this.$store.state.userMail);
            fd.append('passwd',this.$store.state.userPasswd);
            fd.append('cid',this.profile.cid);
            fd.append('newTitle',this.newTitle);
            fd.append('newDes',this.newDes);
            let file = document.querySelector('[type=file]');
            fd.append('upload', file.files[0]);
            // console.log(fd);
            this.axios
                .post(this.$store.state.baseUrl+'/changeInfo/group',fd,
                    {
                        headers: {
                            'Content-Type': `multipart/form-data`
                        }
                    }
                )
                .then(res=>{
                    // console.log(res.data);
                    if(res.data.result===1){
                        console.log('change success');
                        this.$store.commit('partialUpdateGroup',{cid:this.profile.cid,title:this.newTitle,des:this.newDes});
                        this.showSheet=!this.showSheet;
                        alert('change success');
                    }else if(res.data.result===2){
                        console.log('change error');
                        alert('change error');
                    }
                    this.newTitle='';
                    this.newDes='';
                    this.sending=false;
                })
                .catch(err=> {
                    console.log('error');
                    console.log(err);
                });
        }
    },
    computed:{
        level(){
            // 1: not contact user
            // 2: contact user
            // 3: not joined group
            // 4: joined group

            // console.log('level query');
            // console.log('cid or uid '+this.profile.cid+' - '+this.profile.uid);
            // let q=this.$store.state.contactIndex.filter(uid => this.profile.uid)
            //     ,w=this.chatsCid.filter(cid => this.profile.cid);
            // console.log('group query: '+w);
            // console.log('user query: '+q);


            switch(this.profile.category){
                case 'user':
                    if(this.$store.state.contactIndex.filter(uid => uid === this.profile.uid).length === 0){
                        // console.log('user not found');
                        return 1
                    }else{
                        return 2
                    }
                    break;
                case 'group':
                    if(this.chatsCid.filter(cid => cid === this.profile.cid).length === 0){
                        // console.log('group not found');
                        return 3
                    }else{
                        return 4
                    }
                    break;
                default:

            }
        },
        chatsCid(){
            // console.log(this.$store.state.chats.map(obj => obj.cid));
            return this.$store.state.chats.map(obj => obj.cid)
        },
        checkinStatus(){
            if(this.profile.category === 'group'){
                let temp=this.$store.state.chats.filter(chat => chat.cid === this.profile.cid);
                if(temp[0]){
                    let list=temp[0].checkin.split(',');
                    list=list.map(uid => parseInt(uid));
                    if(list.indexOf(this.$store.state.UID) !== -1){
                        return 'checked'
                    }else{
                        return 'not checkin yet'
                    }
                }
            }
            return null
            
        },
        isAdmin(){
            if(this.profile.category === 'group'){
                let temp=this.$store.state.chats.filter(chat => chat.cid === this.profile.cid);
                if(temp[0]){
                    if(this.$store.state.UID === temp[0].admin){
                        return true
                    }else{
                        return false
                    }
                }
            }
            return null
        }
    }
}
</script>
<style>
    .quick-profile {
        display: flex;
        flex-direction: column;
        align-items:center;
    }

    .card-icon {
        margin-bottom:8px;
        max-width: 180px;
        max-height: 180px;
        width: 40vw;
        height: 40vw;
        border-radius: 50%;
        overflow: hidden;
        background-color: #b0bec5;
        align-self: center;
    }

    .card-icon img {
        max-height:100%; 
        max-width:100%;
        object-fit: contain;
    }

    .card-brief-item {
        align-self: center;
        max-width: 320px;
        margin-bottom: 6px;
    }

    .card-name {
        font-size: 28px;
    }

    .card-description {
        font-size: 20px;
        overflow:hidden;  
        text-overflow: ellipsis;
    }

    button.tube-button.full {
        width: 100%;
    }
</style>

